import { MediaChange, MediaObserver } from '@angular/flex-layout';
import {Component, OnInit, ViewChild, Inject, ElementRef, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {MatSidenav, MatSidenavContainer, MatBottomSheet, MatDialog} from '@angular/material';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { SideNavEventHandlerService } from 'src/app/common/event/sidenav-event-handler.service';
import { ScrollEventService } from 'src/app/common/event/scroll-event.service';
import { SupportComponent } from 'src/app/components/support/support.component';
import { LoginService } from 'src/app/services/login.service';
import {Loggedin} from "../../authFilter/platformCentralAuth";
import {ignore} from "selenium-webdriver/testing";
import {FaqComponent} from '../../footer/footer.component';
import {ConfService} from '../../conf.service';
import {AuthService} from '../../user/auth.service';

@Component({
  selector: "app-dashboard-container",
  templateUrl: "./dashboard-container.component.html",
  styleUrls: ["./dashboard-container.component.scss"]
})

export class DashboardContainerComponent implements OnInit, OnChanges {
  loading = false;
  _mNavMode = "side";
  _mNavOpen = false;
  _mShowMenu = false;
  isAuthenticated: string;
  panelOpenState = false;
  isExpanded = false;
  userName: string;
  route: any;
  subscriptions: Subscription[] = [];
  mCurrentHeading = 1;
  domainPartner = '';
  partnerLogo = '';
  brandImage = '';
  loading1 = true;

  FAQ: any;
  accept = false;
  istrue = true;
  _loginStatus;

  localStorageItems = [
    "partner",
    "partnerKey",
    "auth",
    "currentPlanDisplayName",
    "accounts",
    "id",
    "_id",
    "currentPlan"
  ];

  @ViewChild("fixedContent", { static: true }) public fixedContent: ElementRef;

  @ViewChild("mainDrawer", { static: true }) sidenav: MatSidenav;

  @ViewChild("sideNavContainer", { static: true })
  myScrollContainer: MatSidenavContainer;

  @ViewChild("contentScroller", { static: true }) contentScroller: ElementRef;

  @Output() public sidenavToggle = new EventEmitter();
  @Output() sidenavClose = new EventEmitter();

  // async getLogo() {
  //   await this.confPost.getPartnerByName(localStorage.getItem('domainPartner')).toPromise().then(response => {
  //     localStorage.setItem('logo', response['logo']);
  //     localStorage.setItem('brandImage', response['brandImage']);
  //     this.partnerLogo = localStorage.getItem('logo');
  //     this.brandImage = localStorage.getItem('brandImage');
  //   });
  // }

    async domainCheck() {
        let partnerCheck;
        const URL = window.location.href;
        if (!URL.includes('localhost') && !URL.includes('latest.apiplatform.io')) {
            if (URL.includes('//')) {
                const temp = URL.split('//');
                partnerCheck = temp[1].split('.');
            } else {
                partnerCheck = URL.split('.');
            }
            if (partnerCheck.length > 2 && partnerCheck[0] !== 'www') {
              this.domainPartner = partnerCheck[0];
              // if (domainPart.search('-') !== -1) {
              //   domainPart = domainPart.substring(domainPart.indexOf('-') + 1, domainPart.length);
              // }
                await this.confPost.isValidPartner(this.domainPartner).toPromise().then(response1 => {
                    if (response1.status === 200) {
                        localStorage.setItem('domainPartner', this.domainPartner);
                        // this.getLogo();
                    }
                }, error => {});
            }
        }
        this.loading = true;
    }

  ngOnChanges(changes: SimpleChanges) {
      this.route = this.router.url;
  }

  async ngOnInit() {
    this.route =  this.router.url;
    // await this.domainCheck();
    this.domainPartner = localStorage.getItem('domainPartner');
    this.partnerLogo = localStorage.getItem('logo');
    this.brandImage = localStorage.getItem('brandImage');
    this.loading1 = false;
    this.userName = (localStorage.getItem('partner') ? localStorage.getItem('partner') : 'Guest');
    this.isAuthenticated = localStorage.getItem('Auth');
  /*  this.auth = localStorage.getItem("auth");
    if (this.auth === "true") {
      this.loginService.checkAuthentication("loginSuccess");
    }*/

    this.subscriptions[
      this.subscriptions.length
    ] = this.scrollEventService
      .getActionMainEmitter()
      .subscribe((heading: Number) => {
        this.mCurrentHeading = heading as number;
        this.scrollToHeader(heading);
      });

    /*this.loginService.currentStatus.subscribe(loginStatus => {
      this._loginStatus = loginStatus;
      if (this._loginStatus === "loginSuccess") {
        this.isAuthenticated = true;
      } else {
        this.isAuthenticated = false;
      }
    });*/
  }

  constructor(
    private location: Location,
    public router: Router,
    private dialog: MatDialog,
    private scrollEventService: ScrollEventService,
    private media: MediaObserver,
    private sideNavEventHandlerService: SideNavEventHandlerService,
    private _bottomSheet: MatBottomSheet,
    private auth: AuthService,
    private loginService: LoginService,
    private confPost: ConfService,
    @Inject(DOCUMENT) private document: any
  ) {
    this.media.media$.subscribe((mediaChange: MediaChange) => {
      this._mNavMode = this.getMode(mediaChange);
      this.updateSlideMode(mediaChange);
      // this.opened = this.getOpened(mediaChange);
      this.router.events.subscribe(val => {
        if (this.location.path() != "") {
          let routePath = this.location.path();

          return;
        } else {
        }
      });
    });
  }

  openFAQDialog(){
    const dialogRef = this.dialog.open(FaqComponent, {
      data: this.FAQ
    });

    dialogRef.afterClosed().subscribe(result => {
      this.accept = result;
    });
  }

  _toggleSideNav(sideNav) {
    // if (sideNav.opened == false) {
    this._drawerOpened = !this._drawerOpened;
    // }
  }

  _backdropToggle(type) {
    if (type == "backdrop") {
      this._drawerOpened = !this._drawerOpened;
    }
  }

  navigateTo(heading: Number) {
    this.scrollEventService.emitHeadingEvent(heading);
    // this.closeDrawer()
  }
  scrollToHeader(heading: Number) {
    let headerClass: String = this.getHeaderClass(heading);
  }
  getHeaderClass(heading: Number): String {
    // switch (heading) {
    //   case ScrollEventService.SUB_HEADING.home:
    //     return '#home'

    //   default:
    //     break;
    // }
    return "";
  }

  scrollTop(){
    this.contentScroller.nativeElement.scrollTop = 0;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onActivate(e, outlet) {
    this.contentScroller.nativeElement.scrollTop = 0;
    // this.myScrollContainer.scrollable.getElementRef().nativeElement.scrollTop = 0;
  }
  getMode(mediaChange: MediaChange): string {
    if (this.media.isActive("lt-md")) {
      //this._mNavOpen = false;
      return "";
    } else {
      //this._mNavOpen = false;
      return "side";
    }
  }

  _slideMode = "over";
  _drawerOpened: boolean = false;
  private updateSlideMode(mediaChange: MediaChange) {
    if (this.media.isActive("lt-md")) {
      this._slideMode = "over";
      this._drawerOpened = false;
    } else {
      this._slideMode = "over";
      this._drawerOpened = false;
    }
  }
  onActionLaunch(event) {
    this._mNavOpen = true;
    const isOpened = this.sidenav.opened;
    this.sidenav.toggle();
    this.sideNavEventHandlerService.emitMainEvent(!isOpened);
  }

  _openSupportSheet() {
    this._bottomSheet.open(SupportComponent);
  }

  /*logout() {
    for (let i = 0; i < this.localStorageItems.length; i++) {
      localStorage.removeItem(this.localStorageItems[i]);
    }
    localStorage.removeItem("token")
    this.loginService.checkAuthentication("logoutSuccess");
    this.router.navigateByUrl("/");
  }*/
  logout() {
    this.auth.logout();
  }
}
